import { render, staticRenderFns } from "./combination.vue?vue&type=template&id=8e30801c&scoped=true"
import script from "./combination.vue?vue&type=script&lang=js"
export * from "./combination.vue?vue&type=script&lang=js"
import style0 from "./combination.vue?vue&type=style&index=0&id=8e30801c&prod&lang=less&scoped=true"
import style1 from "./combination.vue?vue&type=style&index=1&id=8e30801c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e30801c",
  null
  
)

export default component.exports